var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "welcome-part flex flex-col h-full" }, [
    _c("span", { staticClass: "text" }, [
      _vm._v(
        "\n\t\tAls Kunde einer CashPool-Partnerbank können Sie mit Ihrer girocard/ec-Karte bundesweit an rund 2.800\n\t\tGeldautomaten kostenlos Bargeld abheben.\n\t"
      )
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "text" }, [
      _vm._v(
        "Der nächste Geldausgabeautomat ist näher als Sie denken. Überzeugen Sie sich selbst."
      )
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "logo",
      attrs: { src: "images/Startansicht_Map.png" }
    }),
    _vm._v(" "),
    _vm.showBadges
      ? _c(
          "div",
          { staticClass: "badge-container flex-grow flex flex-row flex-wrap" },
          [_vm._m(0), _vm._v(" "), _vm._m(1)]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://apps.apple.com/de/app/cashpool-geldautomaten/id448616258"
        }
      },
      [
        _c("img", {
          staticClass: "badge",
          attrs: { src: "images/apple-app-store-badge.svg" }
        })
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://play.google.com/store/apps/details?id=de.yellowmap.cashpool"
        }
      },
      [
        _c("img", {
          staticClass: "badge",
          attrs: { src: "images/google-play-badge.png" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }